var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-dark btn-with-image",attrs:{"pill":""}},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.alt}}),_c('span',[_vm._t("default")],2),_vm._v(" › ")])}
var staticRenderFns = []

export { render, staticRenderFns }